import { EventRegistry } from 'app/shared/events/event_registry';
import { Button } from 'app/agriculture/components/Button/Button';
import { ComponentProps } from 'react';

export enum AgricultureToastType {
    WARNING = 'warning',
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
}

export interface AgricultureToastProps {
    title: string;
    subtext?: string;
    type: AgricultureToastType;
    variant?: 'simple' | 'detailed';
    actions?: ComponentProps<typeof Button>[];
    showOnClickAway?: boolean;
}

export class AgricultureToastService {
    private _eventRegistry: EventRegistry<any>;

    constructor() {
        this._eventRegistry = new EventRegistry();
    }

    public onMessage(callback: (toast: AgricultureToastProps) => void): () => void {
        return this._eventRegistry.addEventListener(callback);
    }

    public async showToast(message: AgricultureToastProps): Promise<void> {
        await this._eventRegistry.notifyListeners(message);
    }

    public async hideToast() {
        await this._eventRegistry.notifyListeners(null);
    }
}
